import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';

// app
import { SummaryView } from './Summary.view';
import { enqueueNotification, fullScreenModal, hideModal } from 'stores';
import { UploadBDXContext } from '../UploadBDX.context';
import { UPLOAD_BDX_STEPS } from 'consts';
import { BDX_REQUIRED_BDX, useSubmitBDX } from 'lib/binderManagement';
import * as utils from 'utils';
import { useQueryClient } from 'react-query';

export default function Summary({ fullScreen, handlers, callbackOnSuccess, isTest }) {
  const dispatch = useDispatch();
  const { mutateAsync: submitBDX } = useSubmitBDX();
  const queryClient = useQueryClient();

  const [fullView, setFullView] = useState(false);

  const {
    requestId,
    facility,
    sheetName,
    setRequestId,
    setRowId,
    setExpectedFields,
    setSpreadsheetFields,
    setSheetName,
    setStoredMappingValues,
  } = useContext(UploadBDXContext);

  const toggleFullScreen = () => {
    if (fullView === fullScreen) {
      dispatch(fullScreenModal());
    }

    setFullView((fv) => !fv);
  };

  const handleSubmit = async () => {
    try {
      handlers.setLoading(true);
      const { data } = await submitBDX({ requestId });

      if (data.status === 'MAPPING_REQUIRED') {
        setRequestId(data.requestId);
        setRowId(data.rowId);
        setExpectedFields(data.expectedMapperFields);
        setSpreadsheetFields(data.spreadsheetFields);
        setSheetName(data.sheetName);
        setStoredMappingValues({});
        handlers.getHandleSetStep(UPLOAD_BDX_STEPS.FIELD_MAPPING)();
        dispatch(enqueueNotification('notification.bdx.mappingRequired'));
      }

      if (data.status === 'SUCCESS') {
        setRequestId(data.requestId);
        setSheetName(data.sheetName);

        dispatch(enqueueNotification('notification.bdx.sheetSubmit', 'success'));
      }

      if (data.status === 'COMPLETED') {
        dispatch(hideModal('UPLOAD_BDX'));
        if (utils.generic.isFunction(callbackOnSuccess)) {
          callbackOnSuccess();
        }
        dispatch(enqueueNotification('notification.bdx.submitSuccess', 'success'));
      }

      queryClient.invalidateQueries([BDX_REQUIRED_BDX, facility.umr]);
    } finally {
      handlers.setLoading(false);
    }
  };

  return (
    <SummaryView
      toggleFullScreen={toggleFullScreen}
      fullScreen={fullScreen}
      fullView={fullView}
      handlers={handlers}
      handleSubmit={handleSubmit}
      sheetName={sheetName}
      isTest={isTest}
    />
  );
}
